export class BaseRua {
  region = '';
  contractNumber = '';
  expirationDate: Date = null;   // contract expiration date
  attachmentId = '';   // attachment ID provided by the REST service
}
